var map = {
	"./1.webp": "f61a",
	"./2.webp": "5bcf",
	"./3.webp": "edeb",
	"./4.webp": "9135",
	"./5.webp": "630a",
	"./6.webp": "caf6",
	"./7.webp": "09e3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4867";